module.exports = __webpack_public_path__ + "static/media/MOLDURA_PES_ISTAMBUL_2023_01-BOSFORO.d68e2608.png";